import { ApiError } from './ApiError';

export class ForbiddenError extends ApiError {
  constructor(message: string, errors: unknown[] = []) {
    super(403, message, errors);
    this.name = 'ForbiddenError';
  }
}
